import unescape from 'lodash/unescape';
import clsx from 'clsx';

import { Content } from '@/lib';
import styles from './Code.module.scss';
import { Row } from '../../Row';

export function Code({ code, fluid }: Content.WithFluid<Content.Code>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <code className={styles.code} dangerouslySetInnerHTML={{ __html: unescape(code) }} />
    </Row>
  );
}
